import {
    BarController,
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    ChartData,
    LegendItem,
    LineController,
    LineElement,
    LinearScale,
    PointElement,
    Tooltip,
    TooltipItem,
} from "chart.js"
import * as React from "react"
import { Chart } from "react-chartjs-2"

ChartJS.register(
    BarController,
    BarElement,
    CategoryScale,
    LineController,
    LineElement,
    LinearScale,
    PointElement,
    Tooltip,
)

interface Props {
    showLabels: boolean
    chartData: ChartData
}

export class ChartComponent extends React.PureComponent<Props> {
    static defaultProps: Partial<Props> = {
        showLabels: false,
    }

    render(): JSX.Element {
        const { chartData } = this.props

        return (
            <div className="tw-max-h-1/3-screen">
                <Chart
                    type="bar"
                    data-ft-component="indicatorChart"
                    data={chartData}
                    options={{
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                display: this.props.showLabels,
                                grid: {
                                    display: false,
                                },
                                ticks: {
                                    color: "#7A7A7B",
                                    font: {
                                        family: "Source Sans Pro",
                                        weight: "bold",
                                        size: 10,
                                    },
                                },
                            },
                            y: {
                                border: {
                                    display: false,
                                    dash: [2, 1],
                                },
                                grid: {
                                    color: "rgba(0,0,0,.2)",
                                    z: 10,
                                },
                                ticks: {
                                    color: "#7A7A7B",
                                    padding: 10,
                                    font: {
                                        family: "Source Sans Pro",
                                        weight: "bold",
                                        size: 10,
                                    },
                                },
                            },
                        },
                        elements: {
                            line: {
                                tension: 0,
                            },
                        },
                        animations: {
                            animateRotate: false,
                            animateScale: false,
                        },
                        plugins: {
                            title: {
                                display: true,
                            },
                            legend: {
                                labels: {
                                    filter: this.isLegendLabelVisible,
                                },
                            },
                            tooltip: {
                                position: "nearest",
                                displayColors: false,
                                callbacks: {
                                    label: this.getTooltipLabel,
                                    title: this.getTooltipTitle,
                                },
                            },
                        },
                    }}
                />
            </div>
        )
    }

    getTooltipTitle = (
        tooltipItems: TooltipItem<"bar">[],
    ): string | string[] => {
        return this.props.showLabels ? "" : tooltipItems[0].label
    }

    getTooltipLabel = (tooltipItem: TooltipItem<"bar">): string | string[] => {
        if (
            this.props.chartData.labels &&
            tooltipItem.dataIndex !== undefined &&
            !!tooltipItem.dataset
        ) {
            const value = tooltipItem.dataset.data[tooltipItem.dataIndex]
            return value?.toString() ?? ""
        }
        return ""
    }

    isLegendLabelVisible = (legendItem: LegendItem): boolean =>
        legendItem.text !== undefined && this.props.showLabels
}

export default Chart
